import PropTypes from 'prop-types';

const Select = ({ label, error, options = [], disabled = false, id, ...props }) => (
  <div>
    {label && (
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: '0.75rem',
          fontWeight: 600,
          color: '#6b7280',
          marginBottom: '4px',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
        }}
      >
        {label}
      </label>
    )}
    <select
      id={id}
      disabled={disabled}
      style={{
        width: '100%',
        padding: '8px 12px',
        border: error ? '1px solid #fca5a5' : '1px solid #d1d5db',
        borderRadius: '8px',
        fontSize: '0.8rem',
        backgroundColor: disabled ? '#f3f4f6' : '#fff',
        color: '#111827',
        cursor: disabled ? 'not-allowed' : 'pointer',
        outline: 'none',
        transition: 'border-color 0.15s, box-shadow 0.15s',
        boxSizing: 'border-box',
      }}
      {...props}
    >
      {options.map((option, idx) => (
        <option key={`${option.value || option.codigo}-${idx}`} value={option.value || option.codigo}>
          {option.label || option.nombre}
        </option>
      ))}
    </select>
    {error && <p style={{ fontSize: '0.7rem', color: '#dc2626', marginTop: '2px', marginBottom: 0 }}>{error}</p>}
  </div>
);

Select.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nombre: PropTypes.string,
    })
  ),
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default Select;
